export default __webpack_public_path__ + "static/media/homebg.b079fc2a.png";